export default "__VITE_ASSET__DjCR18I8__"